// Rich text notes are stored as HTML (e.g. containing inline style="..." attributes for
// colour/background/font formatting). Some WAF/security tooling rejects requests containing
// that pattern, so we base64-encode the HTML before sending it and decode it after fetching,
// keeping the raw markup off the wire entirely.

export const encodeNoteContent = (value) => {
  if (!value) return value;
  const bytes = new TextEncoder().encode(value);
  let binary = "";
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return window.btoa(binary);
};

export const decodeNoteContent = (value) => {
  if (!value) return value;
  const binary = window.atob(value);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};
